/**
 * Creative Create Module
 */
import state from './normal-creative/state';
import getters from './normal-creative/getters';
import mutations from './normal-creative/mutations';
import actions from './normal-creative/actions';

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
